import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDaB6QZ8kzolQ2J2ScixQE0TyB9-KmOEpk",
  authDomain: "bbibbi-cc527.firebaseapp.com",
  projectId: "bbibbi-cc527",
  storageBucket: "bbibbi-cc527.firebasestorage.app",
  messagingSenderId: "726266179573",
  appId: "1:726266179573:web:c8275bdb4ca5b5ccd5fabc"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);

// Messaging 인스턴스
let messaging: any = null;

// Flutter WebView 환경 감지
const isFlutterWebView = () => {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent.toLowerCase();
  console.log('🔍 User-Agent:', navigator.userAgent);
  // User-Agent에 wv(WebView) 표시가 있으면 WebView로 판단
  const isWv = ua.includes('wv') || ua.includes('webview');
  console.log('🔍 isFlutterWebView:', isWv);
  return isWv;
};

// 브라우저 환경에서만 messaging 초기화 (Flutter WebView 제외)
if (typeof window !== 'undefined' && 'serviceWorker' in navigator && !isFlutterWebView()) {
  try {
    messaging = getMessaging(app);
    console.log('✅ Firebase Messaging 초기화 성공');
  } catch (e) {
    console.log('❌ Firebase Messaging 초기화 실패:', e);
  }
} else {
  console.log('⚠️ Firebase Messaging 초기화 스킵 (조건 불충족)');
}

// FCM 토큰 요청
export const requestFCMToken = async (): Promise<string | null> => {
  try {
    if (!messaging) {
      console.log('Messaging not supported in this browser');
      return null;
    }

    // 알림 권한 요청
    const permission = await Notification.requestPermission();
    console.log('알림 권한:', permission);

    if (permission !== 'granted') {
      console.log('알림 권한이 거부되었습니다.');
      return null;
    }

    // Service Worker 등록
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.log('Service Worker 등록:', registration);

    // Service Worker가 활성화될 때까지 대기
    await navigator.serviceWorker.ready;
    console.log('Service Worker 준비 완료');
    console.log('📋 SW 상태 - active:', !!registration.active, 'scope:', registration.scope);

    // FCM 토큰 가져오기
    const currentToken = await getToken(messaging, {
      vapidKey: 'BJSotwD24KSlKWfDWx-9ujgzJQRpL4n6pIHieO49fCFeeRVTEoP_9raKTva-d0IqhUeGRM6nXMo7nkbm2Vnir9s',
      serviceWorkerRegistration: registration
    });

    if (currentToken) {
      console.log('FCM 토큰:', currentToken);
      return currentToken;
    } else {
      console.log('FCM 토큰을 가져올 수 없습니다.');
      return null;
    }
  } catch (error) {
    console.error('FCM 토큰 요청 실패:', error);
    return null;
  }
};

// 포그라운드 메시지 수신
export const onForegroundMessage = (callback: (payload: any) => void) => {
  console.log('🔔 onForegroundMessage 핸들러 등록 시도, messaging:', !!messaging);
  if (!messaging) {
    console.log('❌ Messaging이 null - 포그라운드 메시지 수신 불가');
    return;
  }

  console.log('✅ 포그라운드 메시지 핸들러 등록 완료');
  onMessage(messaging, (payload) => {
    console.log('📩 포그라운드 메시지 수신:', payload);
    callback(payload);
  });
};

// FCM 상태 테스트 함수 (디버깅용)
export const testFCMStatus = async () => {
  console.log('=== FCM 상태 테스트 시작 ===');
  console.log('1. messaging 객체:', !!messaging);
  console.log('2. 알림 권한:', Notification.permission);

  // Service Worker 상태 확인
  const swRegs = await navigator.serviceWorker.getRegistrations();
  console.log('3. 등록된 Service Workers:', swRegs.length);
  swRegs.forEach((reg, i) => {
    console.log(`   [${i}] scope:`, reg.scope, 'active:', !!reg.active);
  });

  // 토큰 재확인
  if (messaging) {
    try {
      const reg = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      const token = await getToken(messaging, {
        vapidKey: 'BJSotwD24KSlKWfDWx-9ujgzJQRpL4n6pIHieO49fCFeeRVTEoP_9raKTva-d0IqhUeGRM6nXMo7nkbm2Vnir9s',
        serviceWorkerRegistration: reg
      });
      console.log('4. FCM 토큰:', token);
    } catch (e) {
      console.log('4. FCM 토큰 오류:', e);
    }
  }

  console.log('=== FCM 상태 테스트 완료 ===');
};

// 전역에서 접근 가능하도록 설정 (디버깅용)
if (typeof window !== 'undefined') {
  (window as any).testFCMStatus = testFCMStatus;
}

export { messaging };
